export default () => {
  const els = document.querySelectorAll('.product-card:not(.product-card--furniture)');

  if (els.length) {
    const updateVariantTitle = (measurementsEl, optionsEl, optionIndex) => {
      const data = measurementsEl.querySelector('.product-f-measurements__dimensions.active').innerText;
      if (!data) return;

      optionsEl.forEach((opt) => {
        const oldVariantTitle = opt.innerText;
        if (!oldVariantTitle.includes(' / ')) return;

        let newVariantTitle = oldVariantTitle;

        if (data.includes(':')) {
          // Replace using key-value pair
          let isTitleReplaced = false;

          data
            .split(',')
            .forEach((metaItem) => {
              if (isTitleReplaced) return;

              const metaKeyValuePair = metaItem.split(':');

              if (metaKeyValuePair[1] && metaKeyValuePair[1].toLowerCase() !== 'null' && metaKeyValuePair[1].toLowerCase() !== 'n/a' && metaKeyValuePair[0] !== metaKeyValuePair[1]) {
                if (metaKeyValuePair[0].includes(' x ')) {
                  newVariantTitle = newVariantTitle.replaceAll(metaKeyValuePair[0], metaKeyValuePair[1]);
                } else {
                  newVariantTitle = newVariantTitle.replaceAll(metaKeyValuePair[0], metaItem.replace(':', ' '));
                }

                if (oldVariantTitle !== newVariantTitle) {
                  isTitleReplaced = true;
                }
              }
            });
        } else if (optionIndex > -1) {
          // Replace using option index
          const variantOptionVals = oldVariantTitle.split(' / ');
          variantOptionVals[optionIndex] = data;
          newVariantTitle = variantOptionVals.join(' / ');
        }

        if (oldVariantTitle !== newVariantTitle) {
          opt.innerText = newVariantTitle;
        }
      });
    };

    els.forEach((el) => {
      const optionLabels = el.dataset.optionLabels && JSON.parse(el.dataset.optionLabels)
        ? JSON.parse(el.dataset.optionLabels).map((opt) => opt.toLowerCase())
        : [];
      const sizeOptIndex = optionLabels.indexOf('size');
      const measurementsEl = el.querySelector('.product-card__variant .product-f-measurements');
      const optionsEl = el.classList.contains('product-card--multivariant')
        ? el.querySelectorAll('.product-card__select option')
        : el.querySelectorAll('.product-card__variant-title');

      if (measurementsEl && optionsEl.length) {
        if (measurementsEl.classList.contains('render-complete')) {
          updateVariantTitle(measurementsEl, optionsEl, sizeOptIndex);
        } else {
          measurementsEl.addEventListener('pfm:render', () => {
            updateVariantTitle(measurementsEl, optionsEl, sizeOptIndex);
          });
        }
      }
    });
  }
};
